import { useQuery } from 'react-query';
import { queryKeys } from './queryKeys';
import { fetchAdminInfoFieldTypes } from '../requests/fetchAdminInfoFieldTypes';

export const useAdminInfoFieldTypesQuery = (options) =>
  useQuery(queryKeys.adminInfoFieldTypes(), fetchAdminInfoFieldTypes, {
    initialData: [],
    ...options,
  });
